var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.01,
    height: 21.009,
    viewBox: "0 0 24.01 21.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.51192,21.00796a0.932,0.932 0 0 1 -0.941,-0.926a0.934,0.934 0 0 1 0.941,-0.928l14.742,0a0.936,0.936 0 0 1 0.942,0.928a0.934,0.934 0 0 1 -0.942,0.926l-14.742,0zm4.47,-2.4a0.934,0.934 0 0 1 -0.942,-0.926a0.935,0.935 0 0 1 0.942,-0.926l1.959,0l0,-1.85a7.476,7.476 0 0 1 -6.448,-6.809a4.977,4.977 0 0 1 -4.493,-4.918l0,-2.258a0.933,0.933 0 0 1 0.941,-0.926l22.126,0a0.934,0.934 0 0 1 0.942,0.926l0,2.258a4.982,4.982 0 0 1 -4.5,4.918a7.483,7.483 0 0 1 -6.691,6.838l0,1.821l1.961,0a0.932,0.932 0 0 1 0.941,0.926a0.932,0.932 0 0 1 -0.941,0.926l-5.797,0zm-2.625,-11.045a5.609,5.609 0 0 0 5.646,5.562a5.609,5.609 0 0 0 5.646,-5.562l0,-5.716l-11.291,0l-0.001,5.716zm-4.477,-4.384a3.109,3.109 0 0 0 2.593,3.044l0,-4.376l-2.593,0l0,1.332zm17.653,3.044a3.109,3.109 0 0 0 2.592,-3.044l0,-1.332l-2.592,0l0,4.376z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/header-icon.8b6453bd1c054103d1f3278bf598a86d.svg";
export { ForwardRef as ReactComponent };